import React, { useState, useEffect } from 'react';

function initials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
}

// Renders a client's logo directly from its public URL (served from disk via
// /api/sd-logos, same as every other logo in the app) with a brand-coloured
// initials tile as the fallback. Returns null when no client.
export function ClientLogo({ client, size = 32, rounded = 'rounded-md', className = '' }) {
  const [err, setErr] = useState(false);
  const logoUrl = client?.logo_url || null;
  const bust = client?.logo_updated_at || '';

  useEffect(() => { setErr(false); }, [logoUrl, bust]);

  if (!client) return null;
  const style = { width: size, height: size };

  if (logoUrl && !err) {
    const src = bust ? `${logoUrl}${logoUrl.includes('?') ? '&' : '?'}v=${encodeURIComponent(bust)}` : logoUrl;
    return (
      <img
        src={src}
        alt={client.name || 'Client'}
        style={style}
        onError={() => setErr(true)}
        className={`${rounded} object-cover bg-white ring-1 ring-black/5 ${className}`}
        data-testid="client-logo-img"
      />
    );
  }
  return (
    <div style={{ ...style, backgroundColor: client.brand_color || '#4f46e5' }}
      className={`${rounded} flex items-center justify-center text-white font-bold flex-shrink-0 ${className}`}
      data-testid="client-logo-fallback" title={client.name}>
      <span style={{ fontSize: Math.max(9, Math.round(size * 0.4)) }}>{initials(client.name)}</span>
    </div>
  );
}

export default ClientLogo;
